// Extract the host from a protocol-less URL value (`www.zappos.com/c/mypage`)
const EXTRACT_HOST_FROM_URL_TEST = /^(.*?)\//;

/**
 * Given a hostname (no scheme or port) and an environmentConfig
 * (from the store state) return the hydra host to use for determining
 * active a/b tests.
 *
 * @param {string} host
 * @param {object} environmentConfig
 */
export const hydraHostForHost = (host, { hydra: { requestToHydraHost } }) => requestToHydraHost[host] || requestToHydraHost['__default__'];

/**
 * Given an array of hydra/url test objects, arrange the tests into an
 * object, keyed on hydra host name.
 *
 * @param {array} tests
 */
export const testsByActiveHost = tests => tests.reduce((testsFor, test) => (test.type === 'url' ? assignActiveHostsForUrlTest(testsFor, test) : assignActiveHostsForHydraTest(testsFor, test)), {});

const addTestToHostList = (testsFor, test, host) => {
  if (!testsFor[host]) {
    testsFor[host] = [];
  }
  testsFor[host].push(test);
  return testsFor;
};

const assignActiveHostsForHydraTest = (testsFor, test) => {
  test.active_hosts.forEach(hydraHost => {
    testsFor = addTestToHostList(testsFor, test, hydraHost);
  });
  return testsFor;
};

const getHostForUrlTest = url => {
  const matches = EXTRACT_HOST_FROM_URL_TEST.exec(url);
  return matches.length === 2 ? matches[1] : null;
};

const assignActiveHostsForUrlTest = (testsFor, test) => {
  // url tests include a `url` field which is host plus path (no protocol), so regex out the host and use that as the hydra host.
  const host = getHostForUrlTest(test.url);
  if (host) {
    testsFor = addTestToHostList(testsFor, test, `https://${host}`);
  } // if we cant extract the host, just ignore the test
  return testsFor;
};
